<template>
    <div v-html="field.html" style="min-height: 50px"></div>
</template>

<script>
export default {
    props: ['value', 'field'],
}
</script>
